import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_RENDIMENTOS_URL || 'http://localhost:5003',
});

export default api;